import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom'

import EmlargeTextArea from './components/EmlargeTextArea';
import Footer from './components/Footer';

const Home = props => {
  const shortCode = /*props.match.params.shortCode || */props.location.hash.slice(1);

  return (
    <div className="App">
      <EmlargeTextArea shortCode={shortCode} />
      <Footer />
    </div>
  );
};

const App = () => (
  <Router>
    <div>
    <Route exact path='/' component={Home} />
    <Route path='/:shortCode' component={Home} />
    </div>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js